import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { SiteDetailTiltAlertService } from '../site-detail-tilt-alert/site-detail-tilt-alert.service';

@Component({
  selector: 'app-site-detail-tilt-alert-hourly',
  templateUrl: './site-detail-tilt-alert-hourly.component.html',
  styleUrls: ['./site-detail-tilt-alert-hourly.component.scss'],
})
export class SiteDetailTiltAlertHourlyComponent implements OnChanges {
  @Input() date: string = '';
  @Input() positionName: string = '';

  isOuter = false; // 外部のユーザかどうか

  constructor(private siteDetailAlertService: SiteDetailTiltAlertService) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.isOuter = this.siteDetailAlertService.isOuterUser();
  }
}
